export class Batch {

  batch_id: number
  batch_number: string
  purchasers: string
  sold_count: number
  count: number
  cost: number
  sold_cost: number
  shipping_fee: number
  sold_shipping_fee: number
  comment: string
  all_arrived: boolean
  goods_cost: number
  sold_goods_cost: number
  _checked?: boolean

  constructor(data: any = {}) {
    this.batch_id = data.batch_id
    this.batch_number = data.batch_number
    this.purchasers = data.purchasers
    this.sold_count = data.sold_count || 0
    this.count = data.count || 0
    this.cost = data.cost || 0
    this.sold_cost = data.sold_cost || 0
    this.shipping_fee = data.shipping_fee || 0
    this.comment = data.comment
    this.all_arrived = data.all_arrived
    this.sold_shipping_fee = data.sold_shipping_fee || 0
    this.goods_cost = data.goods_cost || 0
    this.sold_goods_cost = data.sold_goods_cost || 0
    this._checked = false
  }

  get link(): string {
    return `/batches/${this.batch_id}`
  }

  get tableRowClass(): string {
    return this.all_arrived ? '' : 'warning'
  }

  get original_count(): number {
    return this.count + this.sold_count
  }

  get original_cost(): number {
    return this.cost + this.sold_cost
  }

  get soldRate(): number {
    return this.sold_count / this.original_count
  }

  get total_shipping_fee(): number {
    return this.shipping_fee + this.sold_shipping_fee
  }

  get totalGoodsCost(): number {
    return this.goods_cost + this.sold_goods_cost
  }

}



// WEBPACK FOOTER //
// ./src/app/models/batch/batch.ts